// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@property --gradient{syntax:\"<color>\";inherits:false;initial-value:var(--bg-primary)}.v-gradient--spotlight[data-v-051a2a7e]{--gradient:var(--bg-primary);background-image:linear-gradient(to bottom,transparent 0,var(--gradient) 80px,var(--gradient) 100%);transition:--gradient .25s ease-in-out}.group:focus .v-gradient--spotlight[data-v-051a2a7e],.group:hover .v-gradient--spotlight[data-v-051a2a7e]{--gradient:var(--bg-quinary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
